import { buttonSubTabs } from './ButtonsAndLinks/constants'
import { selectorSubTabs } from './Selectors/constants'
import { brandingTabs } from './constants'

const errorFieldMappings = [
  { pattern: 'split', tab: brandingTabs.selectors, subTab: selectorSubTabs.methodRequest },
  { pattern: 'variant', tab: brandingTabs.selectors, subTab: selectorSubTabs.variant },
  { pattern: 'button_simple', tab: brandingTabs.buttonsAndLinks, subTab: buttonSubTabs.simpleButtons },
  { pattern: 'link', tab: brandingTabs.buttonsAndLinks, subTab: buttonSubTabs.links },
  { pattern: 'button', tab: brandingTabs.buttonsAndLinks, subTab: buttonSubTabs.primaryButtons },
  { pattern: 'logo', tab: brandingTabs.brandAndImages },
  { pattern: 'image', tab: brandingTabs.brandAndImages },
  { pattern: 'brand', tab: brandingTabs.brandAndImages },
  { pattern: 'favicon', tab: brandingTabs.brandAndImages },
  { pattern: 'background', tab: brandingTabs.brandAndImages },
  { pattern: 'cover', tab: brandingTabs.brandAndImages },
]

export const getErrorTabsFromResponse = error => {
  const errorData = error?.response?.data
  if (!errorData || typeof errorData !== 'object') return { tabErrors: {}, subTabErrors: {} }

  const tabErrors = {}
  const subTabErrors = {}

  Object.keys(errorData).forEach(field => {
    const fieldLower = field.toLowerCase()
    const mapping = errorFieldMappings.find(m => fieldLower.includes(m.pattern))

    if (mapping) {
      tabErrors[mapping.tab] = true
      if (mapping.subTab) {
        subTabErrors[mapping.subTab] = true
      }
    }
  })

  return { tabErrors, subTabErrors }
}

export const isFormValid = data => {
  return !!data?.images && !!data?.colors
}

export const getModifyThemePayload = data => {
  const form = new FormData()

  Object.entries(data.images).forEach(([key, image]) => {
    if (image.file) form.append(key, image.file)
    if (image.link) form.append(image.link.key, image.link.url)
  })

  Object.values(data.colors).forEach(colorGroup => {
    if (colorGroup) {
      Object.values(colorGroup.types).forEach(type => {
        Object.values(type.colors).forEach(({ color, backendName }) => {
          form.append(backendName, color)
        })
      })
    }
  })

  return form
}
